import { render, staticRenderFns } from "./EditSpaceTemplate.vue?vue&type=template&id=4f19adb1&scoped=true"
import script from "./EditSpaceTemplate.vue?vue&type=script&lang=js"
export * from "./EditSpaceTemplate.vue?vue&type=script&lang=js"
import style0 from "./EditSpaceTemplate.vue?vue&type=style&index=0&id=4f19adb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f19adb1",
  null
  
)

export default component.exports